import { Voice } from "../text-to-speech.model";

export const naturalVoicesEnUs: Array<Voice> = [
    { 
        isRemote: true,
        default: false,
        lang: 'en-US',
        localService: false,
        name: 'bonnie',
        displayName: 'Natural Voice - Child - Female',
        voiceURI: 'narakeetTextToSpeech?voice=bonnie'
    },
    { 
        isRemote: true,
        default: false,
        lang: 'en-US',
        localService: false,
        name: 'mickey',
        displayName: 'Natural Voice - Child - Male',
        voiceURI: 'narakeetTextToSpeech?voice=mickey'
    },
    { 
        isRemote: true,
        default: false,
        lang: 'en-US',
        localService: false,
        name: 'maya',
        displayName: 'Natural Voice - Adult - Female',
        voiceURI: 'narakeetTextToSpeech?voice=maya'
    },
    { 
        isRemote: true,
        default: false,
        lang: 'en-US',
        localService: false,
        name: 'morgan',
        displayName: 'Natural Voice - Adult - Male',
        voiceURI: 'narakeetTextToSpeech?voice=morgan'
    }
];
